import { TIME_FORMAT } from '@schooly/constants';
import {
  addHours,
  differenceInMinutes,
  format,
  getHours,
  getMinutes,
  parse,
  startOfHour,
} from 'date-fns';

export function parseTime(time: string): Date {
  return parse(time, TIME_FORMAT, new Date());
}

export function getMinutesSinceMidnight(time: string): number {
  const date = parseTime(time);
  return getHours(date) * 60 + getMinutes(date);
}

export function getMinutesDiff(start: string, end: string): number {
  return differenceInMinutes(parseTime(end), parseTime(start));
}

export function getGridBodyHeight(
  timeRange: { start: string; end: string },
  hourHeight: number,
): number {
  const durationMinutes = getMinutesDiff(timeRange.start, timeRange.end);
  return (durationMinutes / 60) * hourHeight;
}

export function formatMinutesToTime(totalMinutes: number): string {
  const date = new Date();
  date.setHours(Math.floor(totalMinutes / 60));
  date.setMinutes(totalMinutes % 60);
  return format(date, TIME_FORMAT);
}

export function floorToHour(time: string): string {
  const date = parseTime(time);
  return format(startOfHour(date), TIME_FORMAT);
}

export function ceilToHour(time: string): string {
  const date = parseTime(time);
  return format(addHours(startOfHour(date), 1), TIME_FORMAT);
}
